class ScrollTimeline {
  constructor(section, callback) {
    this.section = section;
    this.callback = callback;
    this.sleeping = true;
    this.stopped = false;

    this.oldRatio = 0;
    this.ratio = 0;
    this.init();
  }

  init() {
    // Set up scroll observer
    window.addEventListener("scroll", this.onScroll.bind(this));
  }

  onScroll() {
    // Check if the section is in view
    const section = this.section.getBoundingClientRect();
    const top = section.top;
    const bottom = section.bottom;

    let scrollRatio =
      (window.innerHeight - top) / (window.innerHeight + section.height);
    // keep ratio between 0 and 1
    this.ratio = Math.min(1, Math.max(0, scrollRatio));
    this.update(scrollRatio);

    if (top < window.innerHeight && bottom > 0) {
      this.sleeping = false;
    } else {
      this.sleeping = true;
    }
  }

  update() {
    if (this.stopped) {
      return;
    }
    if (this.sleeping) {
      requestAnimationFrame(this.update.bind(this));
      return;
    }

    // ease the ratio
    const ratio = (this.oldRatio += (this.ratio - this.oldRatio) * 0.01);

    this.oldRatio = ratio;

    this.callback(ratio);
    requestAnimationFrame(this.update.bind(this));
  }

  destroy() {
    console.log("destroyed");
    window.removeEventListener("scroll", this.onScroll.bind(this));
    this.stopped = true;
  }
}

/**
 * Utils easing curves
 * */
function easeInOutSine(x) {
  return -(Math.cos(Math.PI * x) - 1) / 2;
}

function easeInOutCubic(x) {
  return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
}

function easeOutSine(x) {
  return Math.sin((x * Math.PI) / 2);
}

function easeOutCubic(x) {
  return 1 - Math.pow(1 - x, 3);
}

class SplitText {
  constructor(element, mode = SplitText.MODES.LINE) {
    this.parent = element;
    this.mode = mode;
    this.text = element.textContent;

    this.fontSize = parseFloat(getComputedStyle(element).fontSize);
    this.fontFamily = getComputedStyle(element).fontFamily;

    this.segments = [];

    this.init();

    if (!this.onResize) {
      this.onResize = debounce(this.init.bind(this), 100);
      window.addEventListener("resize", this.onResize);
    }
  }

  init() {
    this.parent.innerHTML = "";

    switch (this.mode) {
      case SplitText.MODES.CHAR:
        this.initChar();
        break;
      case SplitText.MODES.WORD:
        this.initWord();
        break;
      case SplitText.MODES.LINE:
        this.initLine();
        break;
      default:
        break;
    }
  }

  initLine() {
    this.segments = [];

    fontsCtx.font = `${this.fontSize}px ${this.fontFamily}`;
    const lines = wrapText(fontsCtx, this.text, 0, 0, this.parent.clientWidth);

    lines.forEach((line) => {
      const span = document.createElement("span");
      span.textContent = line;
      span.style.display = "inline-block";
      span.classList.add("Split--line");
      this.parent.appendChild(span);
      this.segments.push(span);
    });
  }

  initWord() {
    this.segments = [];

    const words = this.text.split(" ");
    words.forEach((word) => {
      const span = document.createElement("span");
      span.textContent = word;
      span.classList.add("Split--word");
      this.parent.appendChild(span);
      this.segments.push(span);
    });
  }

  initChar() {
    this.segments = [];

    const chars = this.text.split("");
    chars.forEach((char) => {
      const span = document.createElement("span");
      span.textContent = char;
      span.classList.add("Split--char");
      if (char === " ") {
        span.classList.add("Split--space");
      }
      this.parent.appendChild(span);
      this.segments.push(span);
    });
  }

  static get MODES() {
    return {
      CHAR: "char",
      WORD: "word",
      LINE: "line",
    };
  }
}

/* dependencies */
function wrapText(ctx, text, x, y, maxWidth) {
  let words = text.split(" ");
  let line = "";
  const lines = [];

  for (let i = 0; i < words.length; i++) {
    let testLine = line + words[i] + " ";
    let metrics = ctx.measureText(testLine);
    let testWidth = metrics.width;

    if (testWidth > maxWidth && i > 0) {
      ctx.fillText(line, x, y);
      lines.push(line);
      line = words[i] + " ";
    } else {
      line = testLine;
    }
  }

  lines.push(line);

  return lines;
}

let fontsCanvas = document.createElement("canvas");
let fontsCtx = fontsCanvas.getContext("2d");

fontsCtx.font = "16px ResidenzGroteskRegular";
fontsCtx.fillStyle = "black";
fontsCtx.textRendering = "geometricPrecision";

const initSplitText = () => {
  const splitTargets = document.querySelectorAll(".SplitText");

  splitTargets.forEach((target) => {
    const mode = target.dataset.mode || SplitText.MODES.LINE;
    const splitText = new SplitText(target, mode);
    splitText.init();
  });
};

initSplitText();

function debounce(callback, delay = 300) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback.apply(this, args);
    }, delay);
  };
}

/**
 * Parallax images
 */
const parallaxSections = document.querySelectorAll(".ParallaxImage");
parallaxSections.forEach((section) => {
  const parallaxImage = section.querySelector(".ParallaxInner");

  const parallaxTimeline = new ScrollTimeline(section, (ratio) => {
    const translateY = ratio * 15;
    parallaxImage.style.translate = `0 ${translateY}%`;
  });
});

/**
 * Accordions
 */

const accordions = document.querySelectorAll(".Accordion");

accordions.forEach((accordion) => {
  const accordionTriggers = accordion.querySelectorAll(
    ".Accordion--tab-trigger"
  );

  accordionTriggers.forEach((trigger) => {
    const content = trigger.querySelector(".Accordion--tab-content");
    const contentHeight = content.scrollHeight;
    trigger.style.setProperty("--height", `${contentHeight}px`);

    window.addEventListener("resize", () => {
      const contentHeight = content.scrollHeight;
      trigger.style.setProperty("--height", `${contentHeight}px`);
    });

    const collapse = trigger.querySelector(".Accordion--tab");

    trigger.addEventListener("click", () => {
      collapse.classList.toggle("Open");
    });
  });
});

/**
 * Dropdown
 */

const dropdowns = document.querySelectorAll(".Dropdown");

dropdowns.forEach((dropdown) => {
  initDropdown(dropdown);
});

subscribe(PUB_SUB_EVENTS.contentAdded, (e) => {
  const dropdowns = e.content.querySelectorAll(".Dropdown");

  dropdowns.forEach((dropdown) => {
    initDropdown(dropdown);
  });
});

function initDropdown(dropdown) {
  const content = document.createElement("div");
  content.classList.add("Dropdown--options");

  const select = dropdown.querySelector("select");
  const options = Array.from(select.querySelectorAll("option"));

  options.forEach((option) => {
    const item = document.createElement("div");
    item.classList.add("Dropdown--option");
    item.textContent = option.textContent;
    item.dataset.value = option.value;

    if (option.selected) {
      item.classList.add("Selected");
    }
    if (option.disabled) {
      item.classList.add("Disabled");
    }

    item.addEventListener("click", () => {
      select.value = option.value;
      const event = new Event("change", { bubbles: true });
      select.dispatchEvent(event);

      dropdown.querySelectorAll(".Dropdown--option").forEach((el) => {
        el.classList.remove("Selected");
      });

      item.classList.add("Selected");
    });

    content.appendChild(item);
  });
  dropdown.appendChild(content);

  dropdown.addEventListener("click", () => {
    dropdown.classList.toggle("Open");
  });
}

document.addEventListener('mahina-rsvp-modal-open', (e) => {
  console.log('open rsvp modal', e.detail);
});

document.addEventListener('mahina-rsvp-submitted', (e) => {
  console.log('mahina-rsvp-submitted', e.detail);
});

document.addEventListener('mahina-shopify-product-update', (e) => {
  console.log('mahina-shopify-product-update', e.detail);
  const title = e.detail.productTitle;

  const button = document.querySelector('.ma-primary-button');

  if(e.detail.variants[0].inventoryQuantity == 0 ){
    console.log('out of stock');
    button.textContent = 'Out of stock';

    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const handleizedTitle = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      window.location.href = `/products/${handleizedTitle}`;
    });
  }
});

document.addEventListener('mahina-ticket-modal-open', (e) => {
  console.log('mahina-ticket-modal-open', e.detail);
});

document.addEventListener('mahina-event-clicked', (e) => {
  console.log('mahina-event-clicked', e.detail);
});

document.addEventListener('mahina-calendar-update', (e) => {
  console.log('mahina-calendar-update', e.detail);
});

document.addEventListener('mahina-event-loaded', (e) => {
  console.log('mahina-event-loaded', e.detail);
});